// TODO: move type to correct folder/file
import { MonitoringDateFilter } from '../../monitoring/types';
import { SortDirection } from '../../shared/utils/constants';

export enum ReportType {
  VISITED_LOCATIONS = 'VISITED_LOCATIONS',
  WORKDAY_DURATION = 'WORKDAY_DURATION',
  CONDITIONAL_EVENTS = 'CONDITIONAL_EVENTS',
  GEOFENCES = 'GEOFENCES',
  TRIPS = 'TRIPS',
}

export type ReportsSlice<T> = Record<ReportType, T>;

export type TransportReport<T> = {
  transports: Record<number, T>;
};

export type TransportsState = number[];
export type StartState = number;
export type EndState = number;
export type StartHourState = string;
export type EndHourState = string;
export type ExcludeWeekendsState = boolean | undefined;
export type DateFilterLabelState = MonitoringDateFilter;

export interface ReportingCommonFilterParams {
  transports: TransportsState;
  start: StartState | null;
  end: EndState | null;
  startHour: StartHourState | null;
  endHour: EndHourState | null;
  excludeWeekends: ExcludeWeekendsState;
  dateFilterLabel: DateFilterLabelState | null;
  filtersApplied: boolean;
}

export interface ReportingSortParams<T> {
  sortBy: T;
  sortDirection: SortDirection;
}

export type ReportTripRequestFilter = {
  transportId: number;
  startDate: string;
  endDate: string;
};
